import React from 'react';

import PropTypes from 'prop-types';

import styles from './TileSmallWithImgSection.module.css';
import { TileSmallWithImg } from '../../TileSmallWithImg/TileSmallWithImg';

export const TileSmallWithImgSection = (props) => {
    return (
        <div className={styles.container}>
            {Array.isArray(props.data) &&
                props.data
                    .filter((item) => item !== null)
                    .map((item) => {
                        return (
                            <li key={item.id}>
                                <TileSmallWithImg
                                    icon={item.icon}
                                    text={item.text}
                                    title={item.title}
                                    titleGradient={item.color?.titleGradient}
                                    bgColor={item.color?.bgColor}
                                />
                            </li>
                        );
                    })}
        </div>
    );
};

TileSmallWithImgSection.propTypes = {
    data: PropTypes.array,
};
